<template>
  <v-autocomplete
    class="field-custom"
    v-model="country"
    :items="items"
    :placeholder="placeholder"
    :item-value="itemValue"
    :item-text="itemText"
    :chips="chips"
    return-object
    outlined
    clearable
    dense
    hide-no-data
    hide-details="auto"
    :rules="rules"
    @change="valueChanged"
  >
    <template v-slot:item="{ item }">
      <span class="capitalizeText">{{ item.name }}</span>
    </template>
    <template slot="no-data">
      <translate class="ml-3">No data available</translate>
    </template>
  </v-autocomplete>
</template>
<script>
export default {
  props: {
    itemValue: {
      default: "id",
    },
    itemText: {
      default: "name",
    },
    placeholder: {
      default: "Select country",
    },
    rules: {},
    value: {},
    chips: {
      type: Boolean,
      default: false,
    },
    items: {}
  },
  data() {
    return {
      country: null,
    };
  },
  watch: {
    value: {
      handler(val) {
        this.country = val;
      }
    }
  },
  mounted() {
    this.country = this.value;
  },
  methods: {
    valueChanged() {
      this.$emit('input', this.country)
    }
  }
};
</script>